/* ============================================================================
   CON ETIQUETA · MOTOR DE MOVIMIENTO · V25 (dueño: movimiento)

   Un módulo, sin librerías, con defer. Las secciones solo ponen atributos
   data-ce-*; este fichero decide CUÁNDO y pone la clase de estado .ce-in. Lo
   que se ve lo pinta conetiqueta-escena.css con transform, opacity y clip-path.
   La tabla «atributo → efecto» está en la dirección de arte (§1.2) y en
   scratchpad/v25/construccion/movimiento-clases.md.

   El motor no adivina: observa únicamente [data-ce-reveal], [data-ce-media],
   [data-ce-barra], [data-ce-hilo] y [data-ce-serie] en todo el documento,
   incluido #MainContent (§1.3), más .ce-filete y .ce-eyebrow, que son el
   puente para los filetes de las cartelas de Horizon, donde no se puede poner
   un atributo (COL-05, /cart y /404). Observadores por página: A (revelado,
   umbral 0, -8 %) y B (la barra móvil en la ficha, o el índice de las páginas
   legales: nunca los dos, porque no hay plantilla con las dos cosas); uno más
   solo si hay imágenes con data-src que cargar (150 %, PO-06). Ningún listener
   de scroll, ningún requestAnimationFrame continuo, ningún setInterval salvo
   el de la serie del escaparate, que va apagada por defecto (§1.4).

   NADA SE ESCONDE ANTES DE QUE EL MOTOR EXISTA (hallazgo movimiento-3-01). El
   estado escondido de los revelados cuelga de html.ce-motor, y esa clase la
   pone este fichero al arrancar, no el <head>. Antes colgaba de .ce-js, que el
   layout escribe en el <head>: la fotografía editorial se recortaba en el
   primer pintado y no se abría hasta que este fichero —que es defer— corría en
   DOMContentLoaded, o sea un segundo largo de rectángulo de papel vacío en la
   primera pantalla de siete plantillas. Ahora, en el MISMO fotograma en que
   firma, el motor marca .ce-ya en todo lo que ya está dentro de la ventana:
   lo que se ve no se revela, se enseña, y solo se observa lo que queda por
   debajo del pliegue. Como el orden es «enseñar primero, firmar después», no
   hay ni un fotograma pintado con nada escondido; y si este fichero no llega,
   no se esconde nada y no hace falta ninguna red que lo destape.

   Queda una red: un centinela destapa a los --ce-t-rescate lo que siga
   escondido dentro de la ventana si el observador no ha avisado.

   Con prefers-reduced-motion: html.ce-sin-movimiento, .ce-in a todo en el
   primer fotograma y ningún observador de movimiento (quedan la carga diferida,
   la barra y el índice, que son función, no adorno). Fuera de aquí, medido y a
   propósito: partirTitular, la cabecera camaleón, luminancia, pausaCinta y el
   revelado de texto (MOV-02, MOV-03, MOV-08, MOV-09, MOV-19, MOV-20, §14.13).
   ========================================================================= */

(function () {
  'use strict';

  var raiz = document.documentElement;

  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)');
  var movil = window.matchMedia('(max-width: 749px)');
  var vistos = new WeakSet();
  var observadores = [];
  var abortar = null;
  var reloj = 0;
  var guardia = 0;

  var DECLARADOS = '[data-ce-reveal], [data-ce-serie], [data-ce-deriva]';

  /* CASCADA (V51). Las rejillas de piezas no declaran movimiento en su Liquid
     —la de colección y la del buscador las pinta Horizon, y esos ficheros no
     son nuestros— así que el motor las siembra él. Medido el 19-9-2026 en el
     tema vivo: /collections/mujer tenía 56 tarjetas y 2 revelados en toda la
     página; /search?q=bolso, 28 tarjetas y CERO. Aquí se arregla de una vez y
     para todas las rejillas, sin tocar una sola sección de Horizon. */
  /* Cada entrada es «selector → gesto». Alzar sube 14 px; máscara abre la foto
     de abajo arriba, que es el gesto de la casa para fotografía. */
  var CASCADAS = {
    /* --- rejillas de piezas ------------------------------------------- */
    '.product-grid > li': 'alzar',                 /* colección y buscador (Horizon) */
    '.ce-rejilla > li': 'alzar',                   /* escaparate de portada, «también» */
    '.ce-pdp-rec__reja > li': 'alzar',             /* recomendadas de la ficha */
    /* Las 28 marcas, PERO no la cinta: esa ya se mueve sola y escalonar una
       marquesina la rompería. */
    '.ce-v26-marcas__lista:not(.ce-v26-marcas__lista--cinta) > li': 'alzar',
    /* --- ficha de producto -------------------------------------------- */
    '.media-gallery__grid > li': 'mascara',        /* las fotos, al bajar */
    '.ce-escalera > li': 'alzar',                  /* material, composición, medidas… */
    '.ce-envio > li': 'alzar',                     /* envío y devoluciones */
    /* --- páginas y diario ----------------------------------------------
       `.ce-prosa` es el cuerpo de texto de TODA la casa: el artículo del
       diario, las cuatro páginas legales, Sobre, Cómo elegimos. Se revelan los
       HITOS —subtítulos, citas, fotos, listas— y NO los párrafos corridos: un
       texto cuyos párrafos aparecen según se lee no es elegante, es un estorbo
       para quien está leyendo. Lo que se mueve es la estructura, no la letra. */
    '.ce-prosa > h2': 'alzar',
    '.ce-prosa > blockquote': 'alzar',
    '.ce-prosa > figure': 'mascara',
    '.ce-prosa > ul > li': 'alzar',
    '.ce-prosa > ol > li': 'alzar',
    '.ce-pagina__lista > li': 'alzar',             /* el índice de las legales */
    '.ce-criterios__fila': 'alzar',                /* «Cómo elegimos» */
    '.ce-criterios__lista > li': 'alzar',
    '.ce-v26-conf__item': 'alzar',                 /* la banda de confianza */
    '.ce-serv__item': 'alzar',                     /* servicios */
    '.ce-pie__lista > li': 'alzar',
    /* --- bolsa y buscador ----------------------------------------------- */
    '.cart-items__table-row': 'alzar'
    /* El panel del buscador predictivo NO se siembra aquí, y conviene saber
       por qué: Horizon lo reemplaza entero en cada tecla. Un elemento sembrado
       después de que el motor haya pasado nace escondido y sin nadie que lo
       observe, o sea un panel de resultados en blanco. Su movimiento es una
       animación de CSS en la hoja, que se dispara sola al insertarse y termina
       siempre visible. Riesgo cero. */
  };
  var CASCADA_PASO = 45;  /* ms entre piezas de la misma tanda */
  var CASCADA_TOPE = 6;   /* piezas escalonadas como mucho: 270 ms de cola */
  var PUENTE = '.ce-filete, #MainContent .ce-eyebrow';
  var EXCLUIR = 'script, style, template, link, .visually-hidden, [hidden]';
  var CUADRO_S = 10; /* segundos por cuadro de la serie (§1.4) */

  function escucha(el, ev, fn, op) {
    el.addEventListener(ev, fn, Object.assign({ signal: abortar.signal }, op || {}));
  }

  function lista(sel, ambito) {
    return Array.prototype.slice.call((ambito || document).querySelectorAll(sel));
  }

  /* MOV-18: ni scripts, ni cajas ocultas. La regla de «menos de 8 px» se
     aplica solo a las clases puente de la V17, que las ponía una heurística:
     un atributo data-ce-reveal es una decisión de la sección y se respeta
     aunque la figure mida 0 px en DOMContentLoaded (imagen sin cargar); si se
     descartara, su máscara no se abriría nunca. */
  function valido(el) {
    if (el.matches(EXCLUIR) || el.closest('[hidden], .visually-hidden')) return false;
    if (el.matches(DECLARADOS)) return true;
    var filete = el.matches('.ce-filete, .ce-eyebrow');
    return filete || el.getBoundingClientRect().height >= 8;
  }

  /* Siembra de la cascada. Se llama ANTES de ensenar(), para que las piezas
     que ya están dentro de la ventana se marquen .ce-ya como todo lo demás y
     la primera pantalla siga apareciendo compuesta (§1.3). No pisa nada: si
     una pieza ya declara su propio revelado, se respeta el suyo. */
  function sembrar() {
    Object.keys(CASCADAS).forEach(function (sel) {
      var gesto = CASCADAS[sel];
      lista(sel).forEach(function (el) {
        /* Si la pieza ya declara su propio revelado, manda el suyo: la sección
           sabe mejor que el motor lo que quiere. */
        if (el.hasAttribute('data-ce-reveal')) return;
        /* Ni se toca lo que ya está dentro de algo que se revela: dos gestos
           encadenados sobre la misma cosa se ven como un tartamudeo. */
        if (el.closest('[data-ce-reveal]')) return;
        /* Ni lo que no se ve. La bolsa, por ejemplo, tiene DOS
           `.cart-items__table-row` por pieza: la de verdad y una cabecera
           dentro de un <thead class="visually-hidden">, que solo existe para
           quien navega con lector de pantalla. Animar algo que nadie ve es, en
           el mejor de los casos, ruido; y si alguna vez no llegara a
           revelarse, sería una fila en opacidad 0. `valido()` ya descarta
           estos casos más abajo, pero `ensenar()` no pasa por ahí: mejor no
           sembrarlos siquiera. */
        if (el.matches(EXCLUIR) || el.closest('[hidden], .visually-hidden')) return;
        el.setAttribute('data-ce-reveal', gesto);
        if (gesto === 'alzar') el.setAttribute('data-ce-cascada', '');
      });
    });
  }

  /* ------------------------------------------------ 1. Revelar (observador A)
     Umbral 0 y -8 % de margen inferior. Solo se observa; el gesto lo decide la
     hoja según el atributo. Cada objetivo entra una vez. La serie se observa
     sin soltarla: dentro/fuera del viewport pausa el cruce (PO-33). */
  function revelar() {
    var objetivos = lista(DECLARADOS + ', ' + PUENTE).filter(function (el) {
      if (vistos.has(el) || !valido(el)) return false;
      vistos.add(el);
      return true;
    });

    /* Posarse no espera al observador ni a fonts.ready: entra en
       DOMContentLoaded (§1.2); la hoja le pone los 240 ms tras la máscara. */
    objetivos = objetivos.filter(function (el) {
      if (el.getAttribute('data-ce-reveal') === 'posarse') { el.classList.add('ce-in'); return false; }
      return true;
    });
    if (!objetivos.length) return;

    /* Sin observador no hay revelado posible: se destapa todo en el sitio
       antes que dejar la página escondida (§0.2.10). */
    if (typeof IntersectionObserver !== 'function') { destapar(objetivos); return; }

    var obs;
    try {
      obs = crearObservador();
    } catch (err) {
      destapar(objetivos);
      return;
    }
    objetivos.forEach(function (el) { obs.observe(el); });
    observadores.push(obs);
  }

  function destapar(l) { l.forEach(function (el) { el.classList.add('ce-in'); }); }

  function crearObservador() {
    var obs = new IntersectionObserver(function (entradas) {
      /* El retardo de tanda de «alzar»: se reparte entre las piezas que entran
         en ESTA llamada, en orden de documento. Una fila de cinco se escalona;
         una pieza suelta no espera. El porqué, largo, está en la hoja. */
      var cascada = entradas.filter(function (e) {
        return e.isIntersecting && e.target.hasAttribute('data-ce-cascada')
               && !e.target.classList.contains('ce-in');
      }).map(function (e) { return e.target; });
      if (cascada.length > 1) {
        cascada.sort(function (a, b) {
          return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
        });
        cascada.forEach(function (el, i) {
          if (i === 0) return;
          el.style.setProperty('--ce-d', Math.min(i, CASCADA_TOPE) * CASCADA_PASO + 'ms');
        });
      }
      entradas.forEach(function (e) {
        var t = e.target;
        /* La deriva (V47) es la unica animacion continua de la casa: la foto
           respira, 1 -> 1,045 en 28 s, ida y vuelta. Una animacion continua
           que sigue corriendo fuera de la ventana es bateria tirada, asi que
           el observador la pausa igual que pausa la serie del escaparate:
           .ce-fuera pone animation-play-state: paused en la hoja. Por eso
           estos objetivos NO se dejan de observar. */
        if (t.hasAttribute('data-ce-deriva')) {
          t.classList.toggle('ce-fuera', !e.isIntersecting);
        }
        if (t.hasAttribute('data-ce-serie')) {
          t.classList.toggle('ce-serie-fuera', !e.isIntersecting);
          if (!t.hasAttribute('data-ce-reveal') || t.classList.contains('ce-in')) return;
        }
        if (!e.isIntersecting) return;
        t.classList.add('ce-in');
        if (!t.hasAttribute('data-ce-serie') && !t.hasAttribute('data-ce-deriva')) obs.unobserve(t);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    return obs;
  }

  /* Centinela (§0.2.10). El rescate de la hoja cubre «el motor no llega»; esto
     cubre «el motor llega y el observador no avisa». Al cumplirse el plazo, lo
     que siga escondido dentro de la ventana o por encima de ella se destapa a
     mano. Lo que está por debajo del pliegue no se toca: eso lo sigue abriendo
     el observador al pasar, que es el gesto de la casa, y destaparlo antes de
     tiempo sería quedarse sin revelado en toda la página. */
  function centinela() {
    var plazo = tiempo('--ce-t-rescate') || 3000;
    guardia = window.setTimeout(function () {
      lista(DECLARADOS + ', ' + PUENTE).forEach(function (el) {
        if (el.classList.contains('ce-in')) return;
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('ce-in');
      });
    }, plazo);
  }

  function tiempo(nombre) {
    var v = getComputedStyle(raiz).getPropertyValue(nombre).trim();
    var n = parseFloat(v) || 0;
    return /ms$/.test(v) ? n : n * 1000;
  }

  /* ------------------------------------------------- 2. Carga diferida (PO-06)
     data-src / data-srcset → src / srcset a 150 % del viewport, para que la
     máscara se abra con la foto ya pedida. Los cuadros del héroe antiguo
     (data-ce-tarde) los copia su propio snippet y no se tocan. */
  function copiar(el) {
    var ss = el.getAttribute('data-srcset');
    var s = el.getAttribute('data-src');
    if (ss) { el.setAttribute('srcset', ss); el.removeAttribute('data-srcset'); }
    if (s) { el.setAttribute('src', s); el.removeAttribute('data-src'); }
  }

  function diferir() {
    var pendientes = lista('img[data-src], source[data-srcset], img[data-srcset]').filter(function (el) {
      return !el.hasAttribute('data-ce-tarde') && !el.closest('[data-ce-serie]') && !vistos.has(el);
    });
    if (!pendientes.length) return;
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        lista('[data-src], [data-srcset]', e.target).forEach(copiar);
        if (e.target.hasAttribute('data-src') || e.target.hasAttribute('data-srcset')) copiar(e.target);
        obs.unobserve(e.target);
      });
    }, { rootMargin: '150% 0px', threshold: 0 });
    pendientes.forEach(function (el) {
      vistos.add(el);
      obs.observe(el.closest('[data-ce-reveal], picture, figure') || el);
    });
    observadores.push(obs);
  }

  /* ------------------------------------- 3. Barra de compra móvil (observador B)
     Aparece cuando el formulario (#ce-compra) sale por arriba; mientras no se
     ve, visibility: hidden la saca también del foco (A11Y-09, §14.1). La raíz
     se alarga hacia abajo: así «intersecta» mientras el formulario está en
     pantalla o por debajo, y solo deja de hacerlo cuando ha salido por arriba.
     Un salto de scroll (ancla, teclado) cruza ese umbral aunque el formulario
     no llegue a verse; con la raíz normal el observador no se enteraría.
     El segundo selector (product-form-component form) es el ancla real hoy:
     la ficha no emite #ce-compra y con él la barra está medida en dos motores
     (petición de ficha; no se quita sin avisar). */
  function barra() {
    var b = document.querySelector('[data-ce-barra]');
    if (!b) return;
    var ancla = document.querySelector('#ce-compra, product-form-component form, .product-form-buttons');
    if (!ancla) return;
    var obs = new IntersectionObserver(function (entradas) {
      var e = entradas[entradas.length - 1];
      b.classList.toggle('ce-in', !e.isIntersecting && movil.matches);
    }, { threshold: 0, rootMargin: '0px 0px 100000px 0px' });
    obs.observe(ancla);
    observadores.push(obs);
  }

  /* ------------------------------- 4. Índice de las páginas (observador B')
     Petición de páginas: el índice de las legales era estático y no decía por
     dónde va el lector. El markup ya está hecho: nav.ce-pagina__indice con un
     enlace por apartado y un id en cada h2 del cuerpo. Aquí solo se marca el
     enlace del apartado en el que se está con aria-current="true"; el aspecto
     lo pinta páginas en su hoja. No es movimiento: también funciona con
     prefers-reduced-motion. Un solo observador y ningún listener de scroll:
     los h2 avisan al cruzar el 30 % superior y ahí se recalcula cuál manda. */
  function indice() {
    var nav = document.querySelector('nav.ce-pagina__indice');
    if (!nav) return;
    var pares = [];
    lista('a[href^="#"]', nav).forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      var h = id && document.getElementById(decodeURIComponent(id));
      if (h) pares.push({ a: a, h: h });
    });
    if (pares.length < 2) return;

    var actual = null;
    var obs = new IntersectionObserver(function () {
      var limite = window.innerHeight * 0.3;
      var elegido = pares[0];
      pares.forEach(function (p) {
        if (p.h.getBoundingClientRect().top <= limite) elegido = p;
      });
      if (elegido === actual) return;
      actual = elegido;
      pares.forEach(function (p) {
        if (p === elegido) p.a.setAttribute('aria-current', 'true');
        else p.a.removeAttribute('aria-current');
      });
    }, { rootMargin: '0px 0px -70% 0px', threshold: 0 });
    pares.forEach(function (p) { obs.observe(p.h); });
    observadores.push(obs);
  }

  /* ------------------------------------------ 5. Serie del escaparate (§1.4)
     Apagada por defecto. Si la sección lleva data-ce-serie, los cuadros 2 y 3
     llegan con data-src, se copian al cargar la página y el cruce avanza cada
     10 s; se para con la pestaña oculta o el escaparate fuera de la ventana.
     Es el único movimiento infinito de la casa. */
  function serie() {
    var caja = document.querySelector('[data-ce-serie]');
    if (!caja || caja.dataset.ceSerieLista) return;
    caja.dataset.ceSerieLista = '1';
    var cuadros = lista('.ce-escaparate__cuadro', caja);
    if (cuadros.length < 2) return;

    var arranca = function () {
      lista('[data-src], [data-srcset]', caja).forEach(copiar);
      if (quieto.matches) return;
      var i = 0;
      reloj = window.setInterval(function () {
        if (document.hidden || caja.classList.contains('ce-serie-fuera')) return;
        cuadros[i].classList.remove('ce-escaparate__cuadro--activo');
        i = (i + 1) % cuadros.length;
        cuadros[i].classList.add('ce-escaparate__cuadro--activo');
      }, CUADRO_S * 1000);
    };
    if (document.readyState === 'complete') arranca();
    else escucha(window, 'load', arranca, { once: true });
  }

  /* ------------------------------------- 6. Cursor «Ver» sobre las baldosas
     Solo dentro de [data-ce-cursor], solo con ratón. Sin listener de scroll:
     un requestAnimationFrame por movimiento del puntero, y ninguno en reposo. */
  function cursor() {
    if (quieto.matches) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var zonas = lista('[data-ce-cursor]');
    if (!zonas.length) return;

    var punto = document.querySelector('.ce-cursor');
    if (!punto) {
      punto = document.createElement('div');
      punto.className = 'ce-cursor';
      punto.setAttribute('aria-hidden', 'true');
      document.body.appendChild(punto);
    }
    var x = 0, y = 0, pintando = false;
    function pintar() {
      punto.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) translate(-50%,-50%)';
      pintando = false;
    }
    zonas.forEach(function (z) {
      escucha(z, 'pointerenter', function () {
        punto.textContent = z.getAttribute('data-ce-cursor') || '';
        punto.classList.add('ce-cursor--on');
      });
      escucha(z, 'pointerleave', function () { punto.classList.remove('ce-cursor--on'); });
      escucha(z, 'pointermove', function (ev) {
        x = ev.clientX; y = ev.clientY;
        if (!pintando) { pintando = true; requestAnimationFrame(pintar); }
      }, { passive: true });
    });
  }

  /* ------------------------------------------- 7. Enseñar lo que ya se ve
     El estado escondido de la hoja cuelga de html.ce-motor. Antes de ponerlo,
     y en el mismo fotograma, se marca con .ce-ya —que apaga ese estado y su
     transición— todo objetivo cuyo borde superior esté por encima del pie de
     la ventana: lo que ya está en pantalla no se revela, se enseña. Solo
     después se firma, así que el navegador no llega a pintar nada escondido.
     Lo que queda por debajo del pliegue se esconde y lo abre el observador al
     pasar, que es el gesto de la casa y el único sitio donde se ve.
     Las lecturas de caja van todas juntas y antes de escribir ninguna clase,
     para que sea un solo recálculo de maqueta. */
  function ensenar() {
    var objetivos = lista('[data-ce-reveal], ' + PUENTE).filter(valido);
    var yaSeVen = objetivos.filter(function (el) {
      return el.getBoundingClientRect().top < window.innerHeight;
    });
    yaSeVen.forEach(function (el) {
      el.classList.add('ce-ya', 'ce-in');
      /* La serie del escaparate sigue necesitando su observador para pausarse
         fuera de la ventana (§1.4), así que esa no se da por vista. */
      if (!el.hasAttribute('data-ce-serie')) vistos.add(el);
    });
    raiz.classList.add('ce-motor');
  }

  /* --------------------------------------------------------------- arranque */
  function apaga() {
    if (abortar) abortar.abort();
    observadores.forEach(function (o) { o.disconnect(); });
    observadores = [];
    if (reloj) { window.clearInterval(reloj); reloj = 0; }
    if (guardia) { window.clearTimeout(guardia); guardia = 0; }
    abortar = new AbortController();
  }

  function init() {
    apaga();
    vistos = new WeakSet();

    /* La cabecera es sólida siempre (§14.13): ni sensor ni camaleón. */
    raiz.classList.add('ce-cab-solida');
    raiz.classList.remove('ce-cab-oscura');
    escucha(document, 'visibilitychange', function () {
      raiz.classList.toggle('ce-oculta', document.hidden);
    });

    if (quieto.matches) {
      /* Sin firma: sin html.ce-motor la hoja no esconde nada y la página
         aparece compuesta, que es justo lo que pide el §1.7. */
      raiz.classList.remove('ce-motor');
      raiz.classList.add('ce-sin-movimiento');
      sembrar();
      lista(DECLARADOS + ', ' + PUENTE).forEach(function (el) { el.classList.add('ce-in'); });
      diferir();
      barra();
      indice();
      serie();
      return;
    }
    raiz.classList.remove('ce-sin-movimiento');

    /* Si algo de esto reventara después de firmar, la página se quedaría con
       media fotografía escondida y sin nadie que la abriera: se retira la
       firma y la hoja vuelve a no esconder nada. */
    try {
      sembrar();
      ensenar();
      revelar();
    } catch (err) {
      raiz.classList.remove('ce-motor');
      lista(DECLARADOS + ', ' + PUENTE).forEach(function (el) { el.classList.add('ce-in'); });
    }
    centinela();
    diferir();
    barra();
    indice();
    serie();
    cursor();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) init(); });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  quieto.addEventListener('change', init);
})();